import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Helmet } from 'react-helmet';
import './Breastfeeding.css';
import Right from '../../right/Right';
import { fetchInitialData2 } from '../../fetchData';
import Service from '../../service/Service';
const service = new Service();

class Breastfeeding extends Component {
    constructor(props) {
        super(props);
        let serverSideData = {};
        let initialData = [];
        let articledata = [];
        let initialDataHistory = [];
        let articledatatabclk = [];
        let moreArticle = '';
        let mlk_qty_val='';
        let mlk_qty='';
        if (__isBrowser__ && window.__initialData__ && window.__initialData__['initialData']) {
            serverSideData = window.__initialData__['initialData'];
            delete window.__initialData__;
        } else {
            if (props.staticContext && props.staticContext.initialData && props.staticContext.initialData['initialData']) {
                serverSideData = props.staticContext.initialData['initialData'];
            }
        }
        if (serverSideData) {
            if (serverSideData['data1'] && serverSideData['data1']['result']) {
                initialData = serverSideData['data1']['result'];
            }
            if (serverSideData['data2']) {
                if (serverSideData['data2']['result']) {
                    articledata = serverSideData['data2']['result'];
                }
                if (serverSideData['data2']['showMoreUrl']) {
                    moreArticle = serverSideData['data2']['showMoreUrl'];
                }
            }
        }
        this.state = {
            initialData: initialData,
            articledata: articledata,
            moreArticle: moreArticle,
            chars_left: 150,
            text_max: 150,
            feedsumary: '',
            seconds: 0,
            minutes: 0,
            selectedtype: '',
            feedType: '',
            childId: '',
            childName: '',
            financialGoal: '',
            totalFeed: '',
            feedId: '',
            feedFlag: '',
            comment: '',
            pumpFeedType: '',
            pauseId: '',
            t: '',
            isLogin: 0,
            startAction: 0,
            textValue: '',
            mintime: 0,
            chksecond: 10,
            mlk_qty_val: 41,
            mlk_qty :136,
        }
        this.starttime = this.starttime.bind(this);
    }
    static initialAction(reqUrl, ftk, authData, uId, childData) {
        var header = {
            'Content-Type': 'application/json',
            'ftk': ftk,
            'uid': uId,
            'access-token': authData['access-token'],
            'user-agent': global.userAgent,
            'isdesktop': global.isdesktop
        }
        let obj1 = {
            url: global.api_url + "breastfeeding/getbreastfeedingsummary",
            body: JSON.stringify({
                "pageSize": 7,
                "pageNo": 1
            })
        };
        let obj2 = {
            url: global.api_url + "breastfeeding/getfeedarticlessummary",
            body: JSON.stringify({
                "pageSize": 3,
                "pageNo": 1
            })
        };
        return fetchInitialData2(obj1, obj2, JSON.stringify(header));
    }
    componentDidMount() {
        document.addEventListener("click", this.domClick);
        if (navigator.onLine) {
            if (!this.state.initialData || (this.state.initialData && this.state.initialData.length < 1)) {
                service.showLoader();
                this.feedsummayApiData();
                this.articleApiData();
            } else {
                localStorage.setItem('feedSummaryData', JSON.stringify(this.state.initialData));
                localStorage.setItem('feedArticleData', JSON.stringify(this.state.articledata));
                localStorage.setItem('moreArticle', JSON.stringify(this.state.moreArticle));
                this.loadStateData();
            }
        } else {
            if (localStorage.getItem('feedSummaryData')) {
                this.setState({ initialData: JSON.parse(localStorage.getItem('feedSummaryData')) }, () => { this.loadStateData(); });
            }
            if (localStorage.getItem('feedArticleData')) {
                this.setState({ articledata: JSON.parse(localStorage.getItem('feedArticleData')) }, () => { this.loadStateData(); });
            }
            if (localStorage.getItem('moreArticle')) {
                this.setState({ moreArticle: JSON.parse(localStorage.getItem('moreArticle')) }, () => { this.loadStateData(); });
            }
            service.hideLoader();
        }
    }
    componentWillUnmount() {
        document.removeEventListener("click", this.domClick);
    }
    domClick(event) {
        if (!event.target.classList.contains('shr_cnt')) {
            var allElements = document.querySelectorAll(".sharing-options");
            var i;
            for (i = 0; i < allElements.length; i++) {
                allElements[i].style.display = "none";
            }
            document.querySelector('.share-overlay').style.display = "none";
        }
    }
    loadStateData() {
        if (global.ftk != '') {
            this.setState({ isLogin: 1 });
        } else {
            this.setState({ isLogin: 0 });
        }
        if (global.userAry['childData']['UserChildList'] && global.userAry['childData']['UserChildList'].length > 0) {
            let childId = global.userAry['childData']['UserChildList'][0].ChildId;
            this.setState({
                childId: childId
            });
            let childName = global.userAry['childData']['UserChildList'][0].ChildName;
            this.setState({
                childName: childName
            });
        }
        if (this.state.initialData && this.state.initialData[0] && this.state.initialData[0].feedSummary && this.state.initialData[0].feedSummary[0]) {
            let feedsumarylt = this.state.initialData[0].feedSummary[0].feedId;
            this.setState({
                feedsumary: feedsumarylt
            });
        }
    }
    feedsummayApiData() {
        var size = 7;
        var postData = {
            "pagesize": size,
            "pageno": 1
        }
        var url = global.api_ci_url + "Breastfeeding/getbreastfeedingsummary";
        service.postServiceCall(url, postData).then((json) => {
            if (json['result']) {
                var dataAry = [];
                dataAry.push(json['result']);

                if (json['result'] == 'Records Not Found') {
                    this.setState({
                        initialData: '',
                        feedsumary: '',
                        initialDataHistory: this.state.initialData
                    });
                }
                else {
                    this.setState({
                        initialData: dataAry[0]
                    }, () => {
                        this.setState({
                            initialDataHistory: this.state.initialData,
                            feedsumary: this.state.initialData[0].feedSummary[0].feedId
                        });
                    });
                }
                if (this.state.initialData.length > 0) {
                    let feedsumarylt = this.state.initialData[0].feedSummary[0].feedId;
                    this.setState({
                        feedsumary: feedsumarylt
                    }, () => { service.loadImages(); this.loadStateData(); });
                    // localStorage.setItem("feed summary count using this settime" + this.state.feedsumary);
                    // setTimeout(() => {
                    //     console.log("window load",this.state.initialData);
                    //  }, 500)
                } else {
                    localStorage.setItem('feedSummaryData', JSON.stringify(json['result']));
                    this.setState({ initialData: json['result'] }, () => { service.loadImages(); this.loadStateData(); });
                }
            }
            service.hideLoader();
        }).catch((error) => {
            console.error(error);
            service.hideLoader();
        });

    }
    articleApiData() {
        var postData = {
            "pagesize": 3,
            "pageno": 1
        }
        var url = global.api_ci_url + "Breastfeeding/getfeedarticlessummary";
        service.postServiceCall(url, postData).then((json) => {
            if (json['result']) {
                if (this.state.articledata.length >= 0) {
                    this.setState({
                        // initialData: json['result'],
                          articledata: json['result'],
                        moreArticle: json['showMoreUrl']
                    }, () => { service.loadImages(); this.loadStateData(); });
                } else {
                    localStorage.setItem('articledata', JSON.stringify(json['result']));
                    localStorage.setItem('moreArticle', JSON.stringify(json['showMoreUrl']));
                    this.setState({
                        initialData: json['result'],
                        moreArticle: json['showMoreUrl']
                    }, () => { service.loadImages(); this.loadStateData(); });
                }
            }
            service.hideLoader();
        }).catch((error) => {
            console.error(error);
            service.hideLoader();
        });

    }
    breastTab() {
        if (!navigator.onLine) {
            alert('Please check internet connection!!');
            return !1
        }
        if (this.state.startAction == 1) {
            document.getElementById("left-right-breast-section").style.display = "block";
            document.getElementById("latest-activity-section").style.display = "none";
        }
        else {
            document.getElementById("latest-activity-section").style.display = "block";
            document.getElementById("left-right-breast-section").style.display = "none";
        }
        document.getElementById("breast-section").style.display = "block";
        document.getElementById("summery-section").style.display = "none";
        document.getElementById("artical-section").style.display = "none";
        document.getElementById("artical-tab").style.color = "rgb(66, 66, 66)";
        document.getElementById("devartical-tab_icon").style.color = "rgb(158,158,158)";
        document.getElementById("artical-tab").style.borderBottom = "none";
        document.getElementById("devsummery-tab_icon").style.color = "rgb(158,158,158)";
        document.getElementById("history").style.color = "rgb(66, 66, 66)";
        document.getElementById("summery-tab").style.borderBottom = "none";
        document.getElementById("breast-tab").style.color = "rgb(245, 105, 150)";
        document.getElementById("breast-tab").style.borderBottom = "2px solid rgb(245, 105, 150)";
        document.getElementById("devbreast-tab_icon").style.color = "rgb(245, 105, 150)";
        document.getElementById("feed").style.color = "rgb(245, 105, 150)";
        document.getElementById("pump-breast-section").style.display = "none";
        document.getElementById("left-breast-tab").style.opacity = "1";
        document.getElementById("right-breast-tab").style.opacity = "1";
        document.getElementById("pump-breast-tab").style.opacity = "1";
    }
    leftBreasTab() {
        if (!navigator.onLine) {
            alert('Please check internet connection!!');
            return !1
        }
        if (this.state.startAction == 0 && document.getElementById('left-feed-type').style.opacity != 1 && document.getElementById('right-feed-type').style.opacity != 1 && document.getElementById("totalFeed").value
            == "") {
            if (this.state.isLogin == 0) {
                service.showAlert("Please Login");
                window.location.href = global.loginUrl + '?URL=' + global.currentURL;
                return false;
            }
            else {
                document.getElementById("left-right-breast-section").style.display = "block";
                document.getElementById("left-breast-tab").style.opacity = "1";
                document.getElementById("right-started-feeding").style.display = "none";
                document.getElementById("left-started-feeding").style.display = "block";
                document.getElementById("left-started-feeding").style.visibility = "visible";
                document.getElementById("latest-activity-section").style.display = "none";
                document.getElementById("pump-breast-section").style.display = "none";
                document.getElementById("pump-breast-tab").style.opacity = "0.3";
                document.getElementById("right-breast-tab").style.opacity = "0.3";
                document.getElementById("feedType").value = "left";
                this.setState({ feedType: "left" });
                var lastfeeddata = document.getElementById("left-started-feeding").textContent;
                if (lastfeeddata == 'Start Feeding') {
                    document.getElementById("left-started-feeding").innerHTML = "Start Feeding";
                }
                // this.lastrecords('left');
                document.getElementById("pause-btn").style.display = "inline-block";
                document.getElementById("pause-btn").style.opacity = "0.3";
                document.getElementById("add-comment").style.opacity = "0.3";
                //document.getElementById("com_btn").style.opacity = "0.3";
                document.getElementById("start-btn").style.display = "inline-block";
                document.getElementById("resume-btn").style.display = "none";
                document.getElementById("stop-btn").style.display = "none";
                document.getElementById("feedId").value = " ";
                document.getElementById("pauseId").value = " ";
                document.getElementById("feedFlag").value = " ";
            }
        }
    }
    rightBreasTab() {
        if (!navigator.onLine) {
            alert('Please check internet connection!!');
            return !1
        }
        if (this.state.startAction == 0 && document.getElementById('left-feed-type').style.opacity != 1 && document.getElementById('right-feed-type').style.opacity != 1 && document.getElementById("totalFeed").value
            == "") {
            if (this.state.isLogin == 0) {
                service.showAlert("Please Login");
                window.location.href = global.loginUrl + '?URL=' + global.currentURL;
                return false;
            }
            else {
                document.getElementById("pause-btn").style.display = "inline-block";
                document.getElementById("pause-btn").style.opacity = "0.3";
                document.getElementById("left-right-breast-section").style.display = "block";
                document.getElementById("left-breast-tab").style.opacity = "0.3";
                document.getElementById("left-started-feeding").style.display = "none";
                document.getElementById("right-started-feeding").style.display = "block";
                document.getElementById("right-started-feeding").style.visibility = "visible";
                document.getElementById("right-breast-tab").style.opacity = "1";
                document.getElementById("latest-activity-section").style.display = "none";
                document.getElementById("pump-breast-section").style.display = "none";
                document.getElementById("pump-breast-tab").style.opacity = "0.3";
                document.getElementById("feedType").value = "right";
                this.setState({ feedType: "right" });
                var lastfeeddata = document.getElementById("right-started-feeding").textContent;
                if (lastfeeddata == 'Start Feeding') {
                    document.getElementById("right-started-feeding").innerHTML = "Start Feeding";
                }
            }
        }
    }
    BreastpumpTab() {
        if (!navigator.onLine) {
            alert('Please check internet connection!!');
            return !1
        }
        if (this.state.startAction == 0) {
            if (this.state.isLogin == 0) {
                service.showAlert("Please Login");
                window.location.href = global.loginUrl + '?URL=' + global.currentURL;
                return false;
            }
            else {
                document.getElementById("pump-breast-section").style.display = "block";
                document.getElementById("pump-breast-tab").style.opacity = "1";
                document.getElementById("latest-activity-section").style.display = "none";
                document.getElementById("left-breast-tab").style.opacity = "0.3";
                document.getElementById("left-right-breast-section").style.display = "none";
                document.getElementById("right-breast-tab").style.opacity = "0.3";
                document.getElementById("left-feed-type").style.opacity = "0.3";
                document.getElementById("right-feed-type").style.opacity = "0.3";
                document.getElementById("feedType").value = "pump";
                this.setState({ feedType: "pump" });
            }
        }
    }

    summaryTab() {
        if (!navigator.onLine) {
            alert('Please check internet connection!!');
            return !1
        }
        this.setState({
            initialDataHistory: this.state.initialData
        })
        if (this.state.initialData && this.state.feedsumary) {
            document.getElementById("summery_response").style.overflowY = "scroll";
        }
        else {
            document.getElementById("summery_response").style.overflowY = "";
        }
        document.getElementById("devbreast-tab_icon").style.color = "rgb(158,158,158)";
        document.getElementById("feed").style.color = "rgb(66, 66, 66)";
        document.getElementById("breast-tab").style.borderBottom = "none";
        document.getElementById("artical-tab").style.color = "rgb(66, 66, 66)";
        document.getElementById("devartical-tab_icon").style.color = "rgb(158,158,158)";
        document.getElementById("artical-tab").style.borderBottom = "none";
        document.getElementById("devsummery-tab_icon").style.color = "rgb(245, 105, 150)";
        document.getElementById("history").style.color = "rgb(245, 105, 150)";
        document.getElementById("summery-tab").style.borderBottom = "2px solid rgb(245, 105, 150)";
        document.getElementById("artical-section").style.display = "none";
        document.getElementById("summery-section").style.display = "block";
        document.getElementById("breast-section").style.display = "none";
        // document.getElementById("summery_panel").style.display = "none";
        document.getElementById("pump-breast-section").style.display = "none";
    }
    articleTab() {
        if (!navigator.onLine) {
            alert('Please check internet connection!!');
            return !1
        }
        this.setState({
            articledatatabclk: this.state.articledata
        })
        document.getElementById("devbreast-tab_icon").style.color = "rgb(158,158,158)";
        document.getElementById("feed").style.color = "rgb(66, 66, 66)";
        document.getElementById("breast-tab").style.borderBottom = "none";
        document.getElementById("devsummery-tab_icon").style.color = "rgb(158,158,158)";
        document.getElementById("history").style.color = "rgb(66, 66, 66)";
        document.getElementById("summery-tab").style.borderBottom = "none";
        document.getElementById("artical-tab").style.color = "#fc88af";
        document.getElementById("devartical-tab_icon").style.color = "#fc88af";
        document.getElementById("artical-tab").style.borderBottom = "2px solid #fc88af";
        document.getElementById("breast-section").style.display = "none";
        document.getElementById("summery-section").style.display = "none";
        document.getElementById("artical-section").style.display = "block";
    }
    startbrstfeed() {
        if (!navigator.onLine) {
            alert('Please check internet connection!!');
            return !1
        }
        document.getElementById('feedFlag').value = "1";
        this.setState({
            feedFlag: "1",
        });
        this.setState({
            startAction: 1
        });
        var strTime = this.formatAMPM();
        var started_feeding = 'Started Feeding:' + strTime + ' Today';
        var feedType = document.getElementById('feedType').value;
        var comment = document.getElementById("comment").value;
        if (feedType == 'left') {
            document.getElementById("left-started-feeding").style.display = "block";
            document.getElementById("left-started-feeding").innerHTML = started_feeding;
        } else if (feedType == 'right') {
            document.getElementById("right-started-feeding").style.display = "block";
            document.getElementById("right-started-feeding").innerHTML = started_feeding;
        }
        document.getElementById("pause-btn").style.opacity = "1";
        document.getElementById("add-comment").style.opacity = "1";
        document.getElementById("start-btn").style.display = "none";
        document.getElementById("stop-btn").style.display = "inline-block";
        document.getElementById("resume-btn").style.display = "none";
        document.getElementById("pause-btn").style.display = "inline-block";
        document.getElementById("pause-btn").style.opacity = "1";
        document.getElementById("add-comment").style.opacity = "1";
        document.getElementById("comment").value = " ";
        document.getElementById("pumpFeedType").value = " ";
        this.addBrestFeeding();
    }
    formatAMPM() {
        var date = new Date();
        var hours = date.getHours();
        var minutes = date.getMinutes();
        minutes = minutes < 10 ? '0' + minutes : minutes;
        var strTime = hours + ':' + minutes;
        return strTime
    }
    addBrestFeeding() {
        if (!navigator.onLine) {
            alert('Please check internet connection!!');
            return !1
        }
        if (document.getElementById("feedType").value) {
            let feedType = document.getElementById("feedType").value;
            this.setState({
                feedType: feedType
            });
        } else {
            this.setState({
                feedType: "",
            });
        }
        if (document.getElementById("childId").value) {
            let childId = document.getElementById("childId").value
            this.setState({
                childId: childId,
            });
        } else {
            this.setState({
                childId: " ",
            });
        }
        if (document.getElementById("childName").value) {
            let childName = document.getElementById("childName").value;
            this.setState({
                childName: childName,
            });
        } else {
            this.setState({
                childName: 0,
            });
        }
        if (document.getElementById("feedId").value) {        //1 get from api responce
            let feedId = document.getElementById("feedId").value;
            this.setState({
                feedId: feedId,
            });
        } else {

            this.setState({
                feedId: " ",
            });
        }
        if (document.getElementById("savecomment").value) {
            let comment = document.getElementById("savecomment").value
            this.setState({
                comment: comment,
            });
        }
        if (document.getElementById("pauseId").value) {  //1
            let pauseId = document.getElementById("pauseId").value;
            this.setState({
                pauseId: pauseId,
            });
        } else {
            this.setState({
                pauseId: "",
            });
        }
        if (document.getElementById("pumpFeedType").value) {
            let pumpFeedType = document.getElementById("pumpFeedType").value
            this.setState({
                pumpFeedType: pumpFeedType,
            });
        } else {
            this.setState({
                pumpFeedType: "",
            });
        }
        if (document.getElementById("feedFlag").value) {
            let feedFlag = document.getElementById("feedFlag").value;
            this.setState({
                feedFlag: feedFlag,
            });
        } else {
            this.setState({
                feedFlag: '',
            });
        }
        if (document.getElementById("totalFeed").value) {
            let totalFeed = document.getElementById("totalFeed").value;
            this.setState({
                totalFeed: totalFeed,
            });
        } else {
            this.setState({
                totalFeed: '',
            });
        }
        let milisec = '';
        if (document.getElementById("feedFlag").value == 2 && this.state.feedType != 'pump') {
            let hrs = 0;
            let min = this.state.minutes;
            let sec = this.state.seconds;
            milisec = ((min * 60000) + (sec * 1000))

        }
        let totalfeeding;
        if(document.getElementById("totalFeed").value!=""){
            totalfeeding = document.getElementById("totalFeed").value;
        }else{
            totalfeeding=0;
        }
        let postData = {
            "feedType": this.state.feedType,
            "feedId": this.state.feedId,
            "comment": this.state.comment,
            "totalFeed":totalfeeding,
            "childId": this.state.childId,
            "childName": this.state.childName,
            "pauseId": this.state.pauseId,
            "pumpFeedType": this.state.pumpFeedType,
            "duration": milisec,
            "feedFlag": document.getElementById("feedFlag").value,
        }
        var url = global.api_ci_url + "Breastfeeding/savebreastfeedingactivity";
        service.postServiceCall(url, postData).then((json) => {
            if (json) {
                if (this.state.feedFlag == 1 && this.state.feedType != 'pump') {
                    this.setState({
                        feedId: json['feedId'],
                    });
                    this.setTimeoutStart();
                }
                if (this.state.feedFlag == 3) {
                    this.setState({
                        pauseId: "'" + json['pauseId'] + "'",
                    });
                    clearTimeout(this.state.t);
                }
                if (this.state.feedFlag == 4) {
                    document.getElementById("feedId").value = json['feedId'];
                    document.getElementById("pauseId").value = json['pauseId'];
                    this.setTimeoutStart();
                }
                if (this.state.feedFlag == 2 && this.state.feedType != 'pump') {
                    this.setState({
                        textValue: ''
                    });
                    this.setState({
                        chars_left: 150
                    });
                    clearTimeout(this.state.t);
                    this.setState({
                        seconds: 0
                    });
                    this.setState({
                        minutes: 0
                    });
                    document.getElementById("feedId").value = "";
                    document.getElementById("pauseId").value = "";
                    document.getElementById("comment").value = "";
                    document.getElementById("savecomment").value = "";
                    document.getElementById("feedFlag").value = 0;
                    this.setState({
                        feedFlag: '0'
                    });
                    this.setState({
                        feedId: ""
                    });
                    this.setState({
                        pauseId: ""
                    });
                    document.getElementById("totalFeed").value = '';
                    document.getElementById("add-comment").style.opacity = "0.3";
                    document.getElementById("artical-section").style.display = "none";
                    document.getElementById("summery-section").style.display = "none";
                    document.getElementById("breast-section").style.display = "block";
                    document.getElementById("latest-activity-section").style.display = "block";
                    document.getElementById("pump-breast-section").style.display = "none";
                    document.getElementById("left-right-breast-section").style.display = "none";
                    document.getElementById("right-breast-tab").style.opacity = "1";
                    document.getElementById("left-breast-tab").style.opacity = "1";
                    document.getElementById("pump-breast-tab").style.opacity = "1";
                    document.getElementById("add-comment").innerHTML = 'Add Comment';
                    var today = new Date();
                    var dd = today.getDate();
                    var mm = today.getMonth() + 1;
                    var yyyy = today.getFullYear();
                    if (dd < 10) {
                        dd = '0' + dd
                    }
                    if (mm < 10) {
                        mm = '0' + mm
                    }
                    today = dd + '.' + mm + '.' + yyyy;
                    var strTime = this.formatAMPM();
                    var started_feeding = 'Last Feeding: ' + strTime + ' on ' + today;
                    var feedType = document.getElementById("feedType").value;
                    if (feedType == 'left') {
                        document.getElementById("left-started-feeding").innerHTML = started_feeding;

                    } else if (feedType == 'right') {
                        document.getElementById("right-started-feeding").innerHTML = started_feeding;
                    }
                    document.getElementById("feedType").value = '';
                    document.getElementById("left-feed-type").style.opacity = "0.3";
                    document.getElementById("right-feed-type").style.opacity = "0.3";
                    document.getElementById("pumpFeedType").value = '';
                    document.getElementById("summery_response").style.backgroundColor = "#fff";
                    this.feedsummayApiData();
                }
                var feedType = document.getElementById('feedType').value;
                if (feedType == 'pump') {
                    this.setState({
                        textValue: ''
                    });
                    this.setState({
                        chars_left: 150
                    });
                    this.setState({
                        pumpFeedType: ''
                    });
                    this.setState({
                        financialGoal: ''
                    });
                    document.getElementById("totalFeed").value = "";
                    document.getElementById("feedId").value = "";
                    document.getElementById("feedType").value = "";
                    document.getElementById("left-breast-tab").style.opacity = "1";
                    document.getElementById("right-breast-tab").style.opacity = "1";
                    document.getElementById("left-feed-type").style.opacity = "0.3";
                    document.getElementById("right-feed-type").style.opacity = "0.3";
                    document.getElementById("pauseId").value = "";
                    document.getElementById("comment").value = "";
                    document.getElementById("savecomment").value = "";
                    document.getElementById('feedFlag').value = "";
                    document.getElementById('totalFeed').value = "";
                    document.getElementById("artical-section").style.display = "none";
                    document.getElementById("summery-section").style.display = "none";
                    document.getElementById("breast-section").style.display = "block";
                    document.getElementById("latest-activity-section").style.display = "block";
                    document.getElementById("pump-breast-section").style.display = "none";
                    document.getElementById("left-right-breast-section").style.display = "none";
                    this.feedsummayApiData();
                }
            }
            else {
                document.getElementById('cmt_title').innerHTML = "Please Try Again.";
                document.getElementById("breastpump_popup").style.display = "block";
            }
            service.hideLoader();
        }).catch((error) => {
            console.error(error);
            service.hideLoader();
        });
    }
    setTimeoutStart() {
        let time = setTimeout(this.starttime, 1000);
        this.setState({
            t: time
        });
    }
    starttime() {
        this.setState({
            seconds: this.state.seconds + 1
        });
        if (this.state.seconds >= 60) {
            this.setState({
                seconds: 0
            });
            this.setState({
                minutes: this.state.minutes + 1
            });
        }
        this.setTimeoutStart();
    }
    brestFeedPause() {
        if (!navigator.onLine) {
            alert('Please check internet connection!!');
            return !1
        }
        if (document.getElementById("pause-btn").style.opacity == "1") {
            document.getElementById('feedFlag').value = "3";
            this.setState({
                feedFlag: "3"
            });
            document.getElementById("start-btn").style.display = "none";
            document.getElementById("resume-btn").style.display = "inline-block";
            document.getElementById("pause-btn").style.display = "none";
            document.getElementById("stop-btn").style.display = "inline-block";
            if (document.getElementById('feedId').value) {
                this.addBrestFeeding();
            } else {
                document.getElementById('cmt_title').innerHTML = "feed id empty.";
                document.getElementById("breastpump_popup").style.display = "block";
            }
        }
    }
    stopbrstfeed() {
        if (!navigator.onLine) {
            alert('Please check internet connection!!');
            return !1
        }
        let feedFlag = "2";
        this.setState({
            feedFlag: 2
        });
        this.setState({
            comment:''
        });
        this.setState({
            startAction: 0
        });
        document.getElementById('feedFlag').value = "2";
        document.getElementById("start-btn").style.display = "inline-block";
        document.getElementById("resume-btn").style.display = "none";
        document.getElementById("pause-btn").style.display = "none";
        document.getElementById("stop-btn").style.display = "none";
        if (document.getElementById('feedId').value) {
            this.addBrestFeeding();
        } else {
            document.getElementById('cmt_title').innerHTML = "Please Try Again.";
            document.getElementById("breastpump_popup").style.display = "block";
        }
    }
    saveBrestPump() {
        if (!navigator.onLine) {
            alert('Please check internet connection!!');
            return !1
        }
        let totalFeed = document.getElementById('totalFeed').value;
        let pumpFeedType = document.getElementById('pumpFeedType').value;
        if ((totalFeed == 0 || totalFeed == ' ') && pumpFeedType == '') {
            document.getElementById('cmt_title').innerHTML = "Please Select Breast and Enter Volume.";
            document.getElementById('breastpump_popup').style.display = "block";
        } else {
            if (pumpFeedType == ' ' || pumpFeedType == '') {
                document.getElementById('cmt_title').innerHTML = "Please Select Breast";
                document.getElementById('breastpump_popup').style.display = "block";
            } else if (totalFeed == 0 || totalFeed == '') {
                document.getElementById('cmt_title').innerHTML = "Please Enter Volume";
                document.getElementById('breastpump_popup').style.display = "block";
            } else {
                let feedFlag = "2";
                this.setState({
                    feedFlag: 2
                });
                this.setState({
                    feedType: "pump"
                });
                this.setState({
                    pumpFeedType: pumpFeedType
                });
                this.setState({
                    totalFeed: totalFeed
                });
                this.setState({
                    startAction: 0
                });
                document.getElementById('feedFlag').value = 2;
                this.addBrestFeeding();
            }
        }
    }
    resumebrstfeed() {
        if (!navigator.onLine) {
            alert('Please check internet connection!!');
            return !1
        }
        let feedFlag = "4";
        this.setState({
            feedFlag: "4"
        });
        document.getElementById('feedFlag').value = "4";
        document.getElementById("resume-btn").style.display = "none";
        document.getElementById("pause-btn").style.display = "inline-block";
        if (document.getElementById('feedId').value && document.getElementById('pauseId').value) {
            this.addBrestFeeding();
        } else {
            document.getElementById('cmt_title').innerHTML = "feed id or pauseId empty.";
            document.getElementById("breastpump_popup").style.display = "block";

        }
    }
    popUpClose() {
        document.getElementById('breastpump_popup').style.display = "none";

    }
    rghtBrestPump() {
        let right = document.getElementById("right-feed-type").style.opacity;
        if (right == 0.3) {
            document.getElementById("right-feed-type").style.opacity = "1";
        }
        else {
            document.getElementById("right-feed-type").style.opacity = "0.3";
        }
        let rightch = document.getElementById("right-feed-type").style.opacity;
        let leftch = document.getElementById("left-feed-type").style.opacity;
        if (leftch == 1 && rightch == 1) {
            document.getElementById('pumpFeedType').value = 'both';
            this.setState({
                pumpFeedType: 'both'
            });
        } else if (leftch == 1) {
            document.getElementById('pumpFeedType').value = 'left';
            this.setState({
                pumpFeedType: 'left'
            });
        } else if (rightch == 1) {
            document.getElementById('pumpFeedType').value = 'right';
            this.setState({
                pumpFeedType: 'right'
            });
        } else {
            document.getElementById('pumpFeedType').value = ' ';
            this.setState({
                pumpFeedType: ' '
            });
        }
    }
    lftBrestPump() {
        let left = document.getElementById("left-feed-type").style.opacity;
        if (left == 0.3) {
            document.getElementById("left-feed-type").style.opacity = "1";
        }
        else {
            document.getElementById("left-feed-type").style.opacity = "0.3";
        }
        let leftlch = document.getElementById("left-feed-type").style.opacity;
        let rightlch = document.getElementById("right-feed-type").style.opacity;
        if (leftlch == 1 && rightlch == 1) {
            document.getElementById('pumpFeedType').value = 'both';
            this.setState({
                pumpFeedType: 'both'
            });
        } else if (leftlch == 1) {
            document.getElementById('pumpFeedType').value = 'left';
            this.setState({
                pumpFeedType: 'left'
            });
        } else if (rightlch == 1) {
            document.getElementById('pumpFeedType').value = 'right';
            this.setState({
                pumpFeedType: 'right'
            });
        } else {
            document.getElementById('pumpFeedType').value = ' ';
            this.setState({
                pumpFeedType: ' '
            });
        }
    }
    cmntBrestPump() {
        document.getElementById("br_comment").style.display = "block";
    }
    cnclcmtBrestPump() {
        this.setState({
            chars_left: 150
        });
        this.setState({
            textValue: ''
        });
        document.getElementById("comment").value = "";
        document.getElementById("br_comment").style.display = "none";
    }
    savecmtBrestPump() {
        var comment = document.getElementById('comment').value;
        this.setState({
            comment: comment
        });
        document.getElementById('savecomment').value = comment;
        var feedType = document.getElementById('feedType').value;
        if (comment == '') {
            if (feedType == 'pump') {
                document.getElementById("add-comment-pump").innerHTML = 'Add Comment'
            } else {
                document.getElementById("add-comment").innerHTML = 'Add Comment'
            }
        } else {
            if (feedType == 'pump') {
                document.getElementById("add-comment-pump").innerHTML = 'Edit Comment'
            } else {
                document.getElementById("add-comment").innerHTML = 'Edit Comment'
            }
        }
        document.getElementById("br_comment").style.display = "none";

    }
    shareOn(articleId) {
        document.querySelector('.sharing-options').style.display = "none";
        var allElements = document.querySelectorAll(".sharing-options");
        var i;
        for (i = 0; i < allElements.length; i++) {
            allElements[i].style.display = "none";
        }
        document.getElementById("share" + articleId).style.display = "block";
        if (screen.width < 767) {
            document.querySelector('.share-overlay').style.display = "block";
        }
    }
    shareAtricle(articleurl, shareoption, articleId) {
        if (!navigator.onLine) {
            alert('Please check internet connection!!');
            return !1
        }
        document.getElementById("share" + articleId).style.display = "none";
        let shareurl = ' ';
        if (shareoption == "facebook") {
            shareurl = "https://www.facebook.com/sharer/sharer.php?u="
        } else if (shareoption == "google") {
            shareurl = "https://plus.google.com/share?url="
        } else if (shareoption == "twitter") {
            shareurl = "https://twitter.com/share?url="
        } else if (shareoption == "pintrest") {
            shareurl = "https://www.pinterest.com/pin/create/button/?url="
        }
        var sharewindow = window.open(shareurl + articleurl, shareoption + '-popup', 'height=350,width=600');
        if (sharewindow.focus) {
            sharewindow.focus()
        }
    }
    changeLikeStatus(articleId, actionStatus, likecount) {
        if (!navigator.onLine) {
            alert('Please check internet connection!!');
            return !1
        }
        if (this.state.isLogin == 0) {
            service.showAlert("Please Login");
            window.location.href = global.loginUrl + '?URL=' + global.currentURL;
            return false;
        }
        else {
            var count = likecount;
            let postData = {
                "articleId": articleId,
                "actionStatus": actionStatus
            }
            var url = global.api_ci_url + "Breastfeeding/savefeedarticleslike";
            service.postServiceCall(url, postData).then((json) => {
                if (json['msg'] != "1") {
                    document.getElementById("breastpump_popup").innerHTML = json[error_message];
                    document.getElementById("cmt_title").innerHTML = json[error_message];
                    document.getElementById("breastpump_popup").style.display = "block";
                }
                else {
                    if (json['msg'] == "1") {
                        if (actionStatus == 1) {
                            count++;
                            document.getElementById("like_div" + articleId).style.display = "inline-block";
                            document.getElementById("unlike_div" + articleId).style.display = "none";
                            document.getElementById("like_count" + articleId).innerHTML = count;
                        }
                    }
                }
                service.hideLoader();
            }).catch((error) => {
                console.error(error);
                service.hideLoader();
            });
        }
    }
    deleteFeed(event) {
        if (this.state.isLogin == 0) {
            service.showAlert("Please Login");
            window.location.href = global.loginUrl + '?URL=' + global.currentURL;
            return false;
        }
        document.getElementById("deleterecords").value = event.target.getAttribute('rel');
        document.getElementById("delete_record").style.display = "block";
    }
    cncldelfeedSum() {
        document.getElementById("delete_record").style.display = "none";
    }
    delfeedSum() {
        document.getElementById("delete_record").style.display = "none";

        var deletefeedId = document.getElementById("deleterecords").value;
        let postData = {
            "feedId": deletefeedId,
        }
        var url = global.api_ci_url + "Breastfeeding/deletebreastfeedsummary";
        service.postServiceCall(url, postData).then((json) => {
            if (json['msg'] == "1") {
                //  document.getElementById("lstdeletediv" + deletefeedId).style.display = "none";
                // document.getElementById("deletediv" + deletefeedId).style.display = "none";
                this.feedsummayApiData();
            }
            service.hideLoader();
        }).catch((error) => {
            console.error(error);
            service.hideLoader();
        });
    }

    brestFeedcomment() {
        if (document.getElementById("add-comment").style.opacity == "1") {
            document.getElementById("br_comment").style.display = "block";
        }
    }
    handleChangecmnt(event) {
        this.setState({
            textValue: event.target.value
        })
        var input = event.target.value;
        this.setState({
            chars_left: this.state.text_max - input.length
        });
    }

    handleChangepumpno(evt) {
        
        var cs= document.getElementById('totalFeed').value.length;
        if (window.innerWidth > 767) {
            if (cs <= 4 && cs > 0) {
                const financialGoal = (evt.target.validity.valid) ? evt.target.value : this.state.financialGoal;
                this.setState({ financialGoal: financialGoal });
                var Width = cs * 40;
                var parentWidth = Width + 90;
                this.setState({ mlk_qty_val: Width,
                    mlk_qty:parentWidth
                });
            }
            else if(cs == 0){
                const financialGoal = (evt.target.validity.valid) ? evt.target.value : this.state.financialGoal;
                this.setState({ financialGoal: financialGoal });
        
                this.setState({ mlk_qty_val: 40,
                    mlk_qty:130
                });
            }
        } else {
            if (cs <= 4 && cs > 0) {
                const financialGoal = (evt.target.validity.valid) ? evt.target.value : this.state.financialGoal;
                this.setState({ financialGoal: financialGoal });
                var Width = cs * 32;
                var parentWidth = Width + 80;
                this.setState({ mlk_qty_val: Width,
                    mlk_qty:parentWidth
                });
            }
            else if(cs == 0)
            {
                const financialGoal = (evt.target.validity.valid) ? evt.target.value : this.state.financialGoal;
                this.setState({ financialGoal: financialGoal });
         
                this.setState({ mlk_qty_val: 32,
                    mlk_qty:90
                });
            }
        }
    }
    changeFirstChar(feedType) {
           return (feedType!="")?feedType.charAt(0).toUpperCase() + feedType.slice(1):'';
    }

    brestFeedTime(data) {
        var feedTime = data.totalFeedDuration.split(":");
        var capfeedtype = this.changeFirstChar(data.feedType);
        return (
            <p className="sum_info_hed_txt M15_42">{data.feedType == 'pump' ?
                (capfeedtype) : `${capfeedtype} Breast`} :
                {
                    (data.feedType == 'pump' ? ' ' + data.totalFeedDuration + ' ml' 
                        : [
                            ((feedTime[0]) && feedTime[0] != '00'
                                ? ' ' + feedTime[0] + ':' + feedTime[1] + ':' + feedTime[2] + ' Hour'
                                : [
                                    ((feedTime[0]) && feedTime[0] == '00' && (feedTime[1]) && feedTime[1] != '00'
                                        ? ' ' + feedTime[1] + ':' + feedTime[2] + ' Min' : ' ' + feedTime[1] + ':' + feedTime[2] + ' Sec'
                                    )]
                            )
                        ]
                    )
                }
            </p>
        )
    }

    render() {

        return (
            <main className="main-container breastfeeding-tool">
                <Helmet
                    title="Breastfeeding Tracker – Track Your Baby’s Feedings Schedule"
                    meta={[
                        { "name": "description", "content": "Breastfeeding tracker will help to keep a track of baby’s breast feeds by each breast or by both, and also helps moms in maintaining the record of feedings & expressed milk." },
                        { "name": "keywords", "content": "prenatal care, pregnancy checkup, medical examination during pregnancy" },
                        { "name": "atdlayout", "content": "tools_sp" }
                    ]}
                />
                <div className="title">
                    <div className="breadcrumb R11_9e">
                        <span><Link to={service.getRedirectUrl("/")} className="R11_9e">Home</Link></span>
                        <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                        <span><Link to={service.getRedirectUrl("/tools")} className="R11_9e">Tools</Link></span>
                        <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                        <span>BreastFeeding Tracker</span>
                    </div>
                    <h1 className="B24_00">Breastfeeding Tracker</h1>
                </div>
                <div className="sub-container left">
                    <div className="br_bck bf_bg_img">
                        <div className="br_tab_con">
                            <div className="br_tab M18_42" id="breast-tab" style={{ color: 'rgb(245, 105, 150)', borderBottom: '2px solid rgb(245, 105, 150)' }} onClick={(e) => { this.breastTab() }}>
                                <i className="br_bottle_ic" id="devbreast-tab_icon" data-icon-font="&#xe046;"></i>
                                <span className="feed" id="feed">Feeding</span>
                            </div>
                            <div className="br_tab M18_42" id="summery-tab" style={{ color: 'rgb(66,66,66)', borderBottom: 'none' }} onClick={(e) => { this.summaryTab() }}>
                                <i className="br_bottle_ic" id="devsummery-tab_icon" data-icon-font="."></i>
                                <span className="history" id="history">History</span>
                            </div>
                            <div className="br_tab M18_42" id="artical-tab" style={{ color: 'rgb(66,66,66)', borderBottom: 'none' }} onClick={(e) => { this.articleTab() }}>
                                <i className="br_bottle_ic" id="devartical-tab_icon" data-icon-font="&#xe030;"></i>
                                <span className="info">Information</span>
                            </div>
                        </div>

                        <div id="breast-section" >
                            <div className="br_mn_tab" id="br_mn_tab">
                                <div className="br_opr" id="left-breast-tab" onClick={(e) => { this.leftBreasTab() }}>
                                    <i className="br_opr_ic" data-icon-font="&#xe03c;" id="left-breast-tab"></i>
                                    <p className="br_opr_txt R10_75" id="left-breast-tab">Left Breast</p>
                                </div>
                                <div className="br_opr" id="right-breast-tab" onClick={(e) => { this.rightBreasTab() }}>
                                    <i className="br_opr_ic" data-icon-font="&#xe040;" id="right-breast-tab"></i>
                                    <p className="br_opr_txt R10_75" id="right-breast-tab">Right Breast</p>
                                </div>
                                <div className="br_opr" id="pump-breast-tab" onClick={(e) => { this.BreastpumpTab() }}>
                                    <i className="br_opr_ic" data-icon-font="&#xe037;" id="pump-breast-tab"></i>
                                    <p className="br_opr_txt R10_75" id="pump-breast-tab">Breast Pump</p>
                                </div>
                            </div>

                            <div id="latest-activity-section" >
                                <div id="latest_activity_response">
                                    {this.state.initialData && this.state.feedsumary != '' ?
                                        (<div className="summery_panel">
                                            <div className="lats_act_sum">
                                                {this.state.initialData.map((data, index) =>
                                                    //{this.createTable(feedsumdata[0])}
                                                    <div className="lats_act_hed" key ={index}>
                                                        <p className="M18_42 sum_title">
                                                            Summary:({data.feedDate})  {data.dayString}  </p>
                                                        {data.dayString != '' && (data.dayString == 'Today' || data.dayString == 'Yesterday') ?
                                                            (
                                                                <div className="lats_act_txt">
                                                                    {
                                                                        data.feedSummary.map((feedarr, index) => (
                                                                            <div className="sum_info" id={`lstdeletediv${feedarr.feedId}`} key={index}>
                                                                                {feedarr.feedType == 'pump' ? (
                                                                                    <i className="sum_ic" data-icon-font="&#xe038;" key={index}></i>
                                                                                ) : [(feedarr.feedType == 'left' ?
                                                                                    <i className="sum_ic" data-icon-font="&#xe03c;"  key={index}></i> : <i className="sum_ic" data-icon-font="&#xe040;" key={index}></i>
                                                                                )]
                                                                                }
                                                                                <div className="sum_left" >
                                                                                    {this.brestFeedTime(feedarr)}
                                                                                    <p className="sum_info_tm R14_75">{feedarr.actualFeedingTime}</p>
                                                                                    <p className="sum_info_tm R14_75">{feedarr.feedingComment}</p>
                                                                                </div>

                                                                            </div>
                                                                        ))
                                                                    }
                                                                </div>
                                                            ) : (

                                                                <div className="lats_act_txt">
                                                                    {data.feedSummary.map((feedarr, index) => (
                                                                        <div className="sum_info" id={`lstdeletediv${feedarr.feedId}`} key={index}>
                                                                            {data.feedType == 'pump' ? (
                                                                                <i className="sum_ic" data-icon-font="&#xe038;" key={index}></i>
                                                                            ) : [(data.feedType == 'left' ?
                                                                               <i className="sum_ic" data-icon-font="&#xe03c;" key={index}></i> : <i className="sum_ic" data-icon-font="&#xe040;" key={index}></i>
                                                                            )]
                                                                            }
                                                                            <div className="sum_left" >
                                                                                {this.brestFeedTime(feedarr)}
                                                                                <p className="sum_info_tm R14_75">{feedarr.actualFeedingTime}</p>
                                                                            </div>

                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            )
                                                        }
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                        )
                                        : (
                                            <div className="empty_summery_panel" >
                                                <div className="lats_act_sum">
                                                    <div className="lats_act_hed">
                                                        <div className="lats_act_main">
                                                            <div className="lats_act_hed">
                                                                <p className="M18_42 latest_heading">Latest Activity </p>

                                                                {this.state.isLogin == 1 ?
                                                                    (<div className="lats_act">
                                                                        <p className="R14_75 lats_act_text">Start Tracking by clicking on either left breast or right breast pump</p> </div>)
                                                                    :
                                                                    (<div className="lats_act">
                                                                        <p className="R14_75 lats_act_text">login to view your breastfeeding activity</p></div>)

                                                                }

                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    }

                                </div>
                            </div>
                            <input type="hidden" name="childName" id="childName" value={this.state.childName} />
                            <input type="hidden" name="childId" id="childId" value={this.state.childId} />
                            <input type="hidden" name="feedId" id="feedId" value={this.state.feedId} />
                            <input type="hidden" name="pauseId" id="pauseId" value={this.state.pauseId} />
                            <input type="hidden" name="feedFlag" id="feedFlag" value={this.state.feedFlag} />
                            <input type="hidden" name="feedType" id="feedType" value={this.state.feedType} />
                            <input type="hidden" name="pumpFeedType" id="pumpFeedType" value={this.state.pumpFeedType} />


                            <div className="main_fun" id="left-right-breast-section" style={{ display: 'none' }} >
                                <div className="tm_con">
                                    <p className="M19_white" id="left-started-feeding" > Start Feeding </p>
                                    <p className="M19_white" id="right-started-feeding"> Start Feeding </p>
                                </div>
                                <div className="counter">
                                    {this.state.minutes < 10 && this.state.seconds < 10 ?
                                        (<div className="timer well R50_white" id="time">
                                            {this.state.mintime}{this.state.minutes}:{this.state.mintime}{this.state.seconds}
                                        </div>)
                                        : [
                                            (this.state.minutes < 10
                                                ? <div className="timer well R50_white" id="time">
                                                    {this.state.mintime}{this.state.minutes}:{this.state.seconds}
                                                </div>
                                                : [
                                                    (this.state.seconds < 10
                                                        ? <div className="timer well R50_white" id="time">
                                                            {this.state.minutes}:{this.state.mintime}{this.state.seconds}
                                                        </div> :
                                                        <div className="timer well R50_white" id="time">
                                                            {this.state.minutes}:{this.state.seconds}
                                                        </div>
                                                    )]
                                            )
                                        ]
                                    }
                                </div>
                                <div className="com_btn" id="com_btn">
                                    <p className="com_btn_txt R14_white" id="add-comment" onClick={(e) => this.brestFeedcomment()}>Add Comment</p>
                                </div>
                                <div className="counter_btn">
                                    <span className="pause" data-icon-font="" id="pause-btn" rel="3" style={{ display: 'inline-block', opacity: '0.3' }} onClick={(e) => { this.brestFeedPause() }}></span>
                                    <span className="resume" data-icon-font="" id="resume-btn" rel="4" style={{ display: 'none' }} onClick={(e) => { this.resumebrstfeed() }}></span>
                                    <span className="start" data-icon-font="" id="start-btn" rel="1" style={{ display: 'inline-block' }} onClick={(e) => { this.startbrstfeed() }}></span>
                                    <span className="stop" data-icon-font="" id="stop-btn" rel="2" style={{ display: 'none' }} onClick={(e) => { this.stopbrstfeed() }} ></span>
                                </div>
                            </div>
                            <div className="br_pump" id="pump-breast-section" style={{ display: 'none' }}>
                                <div className="br_btns">
                                    <div className="left_brst R14_white" id="left-feed-type" rel="0" onClick={(e) => { this.lftBrestPump() }}>
                                        <p id="left-feed-type-text" rel="0">Left Breast</p>
                                    </div>
                                    <div className="right_brst R14_white" id="right-feed-type" rel="0" onClick={(e) => { this.rghtBrestPump() }} >
                                        <p id="right-feed-type-text" rel="0">Right Breast</p>
                                    </div>
                                </div>
                                <div className="mlk_qty R50_white" style={{width:this.state.mlk_qty+'px'}}>                                        
                                    <input type="text" className="mlk_qty_val" style={{width:this.state.mlk_qty_val+'px'}} placeholder="0" pattern="[0-9]+" id="totalFeed" name="totalFeed" onChange={this.handleChangepumpno.bind(this)} value={this.state.financialGoal} />
                                    <span>ml</span>

                                </div>
                                <div className="cmnt R14_white">
                                    <p id="add-comment-pump" onClick={(e) => { this.cmntBrestPump() }} >Add Comment</p>
                                </div>
                                <div className="btn_1">
                                    <i id="start-pump-btn" className="save_pump" data-icon-font="" onClick={(e) => { this.saveBrestPump() }}></i>
                                </div>
                            </div>

                        </div>
                        <div id="summery-section" className="summery_main" style={{ display: 'none' }}>
                            <input type="hidden" id="page_no" name="page_no" value="2" />
                            <div id="summery_response" className="summery_res">
                                <div className="lats_act_sum">
                                    <div className="lats_act_hed">
                                        {this.state.initialDataHistory && this.state.feedsumary != '' ?
                                            (
                                                <div className="lats_act_txt">
                                                    {this.state.initialDataHistory.map((data, index) =>
                                                       <div className="lats_act_hed" key={index}>
                                                            <p className="M18_42 sum_title">
                                                                Summary:({data.feedDate})  {data.dayString}  </p>
                                                            {data.dayString != '' && (data.dayString == 'Today' || data.dayString == 'Yesterday') ?
                                                                (
                                                                    <div className="lats_act_txt">
                                                                        {
                                                                            data.feedSummary.map((feedarr, index) => (
                                                                              <div className="sum_info" id={`deletediv${feedarr.feedId}`} key={index}>
                                                                                    {feedarr.feedType == 'pump' ? (
                                                                                        <i className="sum_ic" data-icon-font="&#xe038;" key={index}></i>
                                                                                    ) : [(feedarr.feedType == 'left' ?
                                                                                        <i className="sum_ic" data-icon-font="&#xe03c;" key={index}></i> : <i className="sum_ic" data-icon-font="&#xe040;" key={index}></i>
                                                                                    )]
                                                                                    }
                                                                                    <div className="sum_left" >
                                                                                        {this.brestFeedTime(feedarr)}
                                                                                        <p className="sum_info_tm R14_75">{feedarr.actualFeedingTime}</p>
                                                                                        <p className="sum_info_tm R14_75">{feedarr.feedingComment}</p>
                                                                                    </div>
                                                                                    <i className="del_ic" data-icon-font="" id="delete-feed" rel={feedarr.feedId} onClick={(e) => this.deleteFeed(e)} ></i>
                                                                                </div>
                                                                            ))
                                                                        }
                                                                    </div>
                                                                ) : (

                                                                    <div className="lats_act_txt">
                                                                        {data.feedSummary.map((feedarr, index) => (
                                                                            <div className="sum_info" id={`deletediv${feedarr.feedId}`} key={index}>
                                                                                {data.feedType == 'pump' ? (
                                                                                    <i className="sum_ic" data-icon-font="&#xe038;" key={index}></i>
                                                                                ) : [(data.feedType == 'left' ?
                                                                                    <i className="sum_ic" data-icon-font="&#xe03c;" key={index}></i> : <i className="sum_ic" data-icon-font="&#xe040;" key={index}></i>
                                                                                )]
                                                                                }
                                                                                <div className="sum_left" >
                                                                                    {this.brestFeedTime(feedarr)}
                                                                                    <p className="sum_info_tm R14_75">{feedarr.actualFeedingTime}</p>
                                                                                </div>
                                                                                <i className="del_ic" data-icon-font="" id="delete-feed" rel={feedarr.feedId} onClick={(e) => this.deleteFeed(e)} ></i>

                                                                            </div>
                                                                        ))}
                                                                    </div>
                                                                )
                                                            }
                                                        </div>
                                                    )}
                                                </div>
                                            )
                                            : (
                                                <div className="lats_act_main">
                                                    <div className="lats_act_hed">
                                                        <p className="M18_42 latest_heading">Latest  Activity {this.state.feedsumary} </p>

                                                        {this.state.isLogin == 1 ?
                                                            (<div className="lats_act">
                                                                <p className="R14_75 lats_act_text">Start Tracking by clicking on either left breast or right breast pump</p> </div>)
                                                            :
                                                            (<div className="lats_act">
                                                                <p className="R14_75 lats_act_text">login to view your breastfeeding activity</p></div>)

                                                        }
                                                    </div>
                                                </div>
                                            )
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div id="artical-section" style={{ display: 'none' }}>
                            {this.state.articledatatabclk ?
                                (
                                    <div>
                                        <div className="br_art_main">
                                            {this.state.articledatatabclk.map((article, index) =>
                                                <div className="aerticleBind" key={index}>
                                                    <div className="br_art_title">
                                                        <a>
                                                            <p className="B16_42">{article.articleTitle}</p>
                                                        </a>
                                                    </div>
                                                    <div className="br_art_1">
                                                        <a>
                                                            <div className="art_img">
                                                                <img src={`${article.articleImage}`.replace(/\.jpg$/i, ".webp")}   onError={(e)=>{e.target.onerror = null; e.target.src=article.articleImage }} />                               
                                                            </div>
                                                        </a>
                                                        <div className="art_desc">
                                                            <p className="desc R15_42">{article.articleText}</p>
                                                            <a className="R14_link" href={article.articleUrl}>Read More</a>
                                                        </div>
                                                        <div className="lyk_shr">
                                                            <div className="like R13_9e">

                                                                <div className="lk_in" id={`like_div${article.articleId}`} style={article.isLiked == 1 ? ({ display: 'inline-block' }) : ({ display: 'none' })} >
                                                                    <a title="Click to Change like Status" onClick={(e) => { this.changeLikeStatus(article.articleId, 1, article.likeCount) }} >
                                                                        <i className="lyk" data-icon-font="&#xe021;" style={{ color: '#f56996' }}></i></a>
                                                                    <p className="lyk_cnt"><span id={`like_count${article.articleId}`} >{article.likeCount}</span> Like</p>
                                                                </div>
                                                                <div className="lk_in" id={`unlike_div${article.articleId}`} style={article.isLiked == '' ? ({ display: 'inline-block' }) : ({ display: 'none' })} >
                                                                    <a title="Click to Change like Status" onClick={(e) => { this.changeLikeStatus(article.articleId, 1, article.likeCount) }} >
                                                                        <i className="lyk" data-icon-font="&#xe020;" style={{ color: '#9e9e9e' }}></i></a>
                                                                    <p className="lyk_cnt"><span id={`like_count${article.articleId}`} >{article.likeCount}</span> Like</p>
                                                                </div>
                                                            </div>

                                                            <div className="share R13_9e" onClick={(e) => { this.shareOn(article.articleId) }}>
                                                                <span className="shr_cnt shr" data-icon-font=")"></span>
                                                                <p className="shr_cnt">&nbsp;Share</p>
                                                                <div className="sharing-options" id={`share${article.articleId}`}>
                                                                    <ul className="">
                                                                        <li className="facebook-share left" onClick={(e) => { this.shareAtricle(article.articleUrl, "facebook", article.articleId) }}>
                                                                            <div className="M16_61 social-share" id="facebook">
                                                                                <img src="//parenting.firstcry.com/tools/images/facebook.png" className="facebookimg" alt="" />
                                                                            </div>
                                                                        </li>
                                                                        <li className="twitter-share left" onClick={(e) => { this.shareAtricle(article.articleUrl, "google", article.articleId) }}>
                                                                            <div className="M16_61 social-share" id="google">
                                                                                <img src="//parenting.firstcry.com/tools/images/google.png" className="googleimg" alt="" />
                                                                            </div>
                                                                        </li>
                                                                        <li className="twitter-share left" onClick={(e) => { this.shareAtricle(article.articleUrl, "twitter", article.articleId) }}>
                                                                            <div className="M16_61 social-share" id="twitter">
                                                                                <img src="//parenting.firstcry.com/tools/images/twitter.png" className="twitterimg" alt="" />
                                                                            </div>
                                                                        </li>
                                                                        <li className="twitter-share left" onClick={(e) => { this.shareAtricle(article.articleUrl, "pintrest", article.articleId) }}>
                                                                            <div className="M16_61 social-share" id="pintrest">
                                                                                <img src="//parenting.firstcry.com/tools/images/pintrest.png" className="pintrestimg" alt="" />
                                                                            </div>
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                        <div className="more-articles M14_white">
                                            <a title="Show More Post" className="morearticle" target="_blank" href="http://parenting.firstcry.ae/subcat/baby/breastfeeding/">Show More Articles</a>
                                        </div>
                                    </div>
                                ) : (
                                    <div><p>Records Not Found </p> </div>
                                )

                            }
                        </div>
                    </div>
                </div>
                <input type="hidden" id="deleterecords" name="deleterecords" value="" />
                <div className="share-overlay"></div>
                <div className="br_overlay delete_popup" id="delete_record" style={{ display: 'none' }}>
                    <div className="delpopup">
                        <p className="cmt_title M18_42">Delete Record?</p>
                        <div className="cmt_btns">
                            <span className="cmt_cancel R14_61 delete-feed-popup" rel="0" onClick={(e) => { this.cncldelfeedSum() }}>CANCEL</span>
                            <span className="cmt_save R14_fc delete-feed-popup" rel="1" onClick={(e) => { this.delfeedSum() }}>DELETE</span>
                        </div>
                    </div>
                </div>
                <div className="br_overlay comment_popup" id="br_comment">
                    <div className="cmt_popup">
                        <p className="cmt_title M18_42">Comments</p>
                        <input type="text" name="comment" id="comment" maxLength="150" value={this.state.textValue} className="add_cmt" placeholder="" onChange={this.handleChangecmnt.bind(this)} />
                        <span className="maxlength-feedback" id="maxlengthcmmt">{this.state.chars_left} characters remaining (150 maximum)</span>
                        <input type="hidden" name="savecomment" id="savecomment" value="" />

                        <div className="cmt_btns">
                            <span className="cmt_cancel R14_61" id="cancel-comment-btn" onClick={(e) => { this.cnclcmtBrestPump() }}>CANCEL</span>
                            <span className="cmt_save R14_fc" id="save-comment-btn" onClick={(e) => { this.savecmtBrestPump() }} >save</span>
                        </div>
                    </div>
                </div>

                <div className="br_overlay plzselect" id="breastpump_popup">
                    <div className="errorpopup " id="errorpopup ">
                        <p className="cmt_title R14_42" id="cmt_title"></p>
                        <div className="cmt_btns">
                            <span className="cmt_cancel R14_61" id="ok-btn" onClick={(e) => { this.popUpClose() }}>OK</span>
                        </div>
                    </div>
                </div>
                <Right url={this.props.match.url} />
            </main>
        )
    }
}

export default Breastfeeding;



// WEBPACK FOOTER //
// src/shared/tools/Breastfeeding/Breastfeeding.js